import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/site";

/**
 * Initiate a Stripe checkout for the given product_id.
 * Redirects the customer to the Stripe-hosted checkout page.
 *
 * @param {Object} opts
 * @param {string} opts.productId - Server-side product key
 * @param {string} opts.language - "de" | "es"
 * @param {string} [opts.email] - Optional pre-fill
 * @param {string} [opts.name]  - Optional pre-fill
 */
export async function startCheckout({ productId, language = "de", email, name }) {
    try {
        const origin = window.location.origin;
        const { data } = await axios.post(`${API}/payments/checkout`, {
            product_id: productId,
            origin_url: origin,
            language,
            customer_email: email,
            customer_name: name,
        });
        if (data?.url) {
            window.location.href = data.url;
            return data;
        }
        throw new Error("missing checkout url");
    } catch (err) {
        console.error(err);
        toast.error(
            language === "de"
                ? "Zahlung konnte nicht gestartet werden. Bitte später erneut versuchen."
                : "No se pudo iniciar el pago. Por favor inténtalo más tarde.",
        );
        throw err;
    }
}
